import { Directive, Input } from '@angular/core';
import { CdkColumnDef } from '@angular/cdk/table';

@Directive({
  selector: '[mcraiColumnDef]',
  providers: [{ provide: CdkColumnDef, useExisting: ColumnDefDirective }]
})
export class ColumnDefDirective extends CdkColumnDef {
  @Input('mcraiColumnDef') name: string;
}
